<template>
  <div class="header">
    <div class="main-header">
      <div class="header-left">
        <router-link :to="homeRoute" class="logo">
          <hr-payroll-mark variant="full" />
        </router-link>
        <router-link :to="homeRoute" class="dark-logo">
          <hr-payroll-mark variant="full" tone="dark" />
        </router-link>
      </div>

      <a
        id="mobile_btn"
        class="mobile_btn"
        @click="toggleSidebar1"
        href="javascript:void(0);"
      >
        <span class="bar-icon">
          <span></span>
          <span></span>
          <span></span>
        </span>
      </a>

      <div class="header-user">
        <div class="nav user-menu nav-list">
          <div class="me-auto d-flex align-items-center" id="header-search">
            <a
              id="toggle_btn"
              href="javascript:void(0);"
              @click="toggleSidebar"
              class="btn btn-menubar me-1"
            >
              <i class="ti ti-arrow-bar-to-left"></i>
            </a>
            <!-- Search -->
            <div class="dq-global-search me-3" ref="searchShellRef">
              <div class="input-group input-group-flat d-inline-flex">
                <span class="input-icon-addon">
                  <i class="ti ti-search"></i>
                </span>
                <input
                  ref="searchInputRef"
                  v-model.trim="searchQuery"
                  type="text"
                  class="form-control"
                  placeholder="Search in HRMS"
                  @focus="handleSearchFocus"
                  @input="handleSearchInput"
                  @keyup.enter="submitHeaderSearch"
                  @keydown.esc="closeSearchDropdown"
                />
                <button
                  v-if="searchQuery"
                  type="button"
                  class="dq-search-clear"
                  @click="clearHeaderSearch"
                >
                  <i class="ti ti-x"></i>
                </button>
                <span class="input-group-text">
                  <kbd>CTRL + /</kbd>
                </span>
              </div>
              <div
                v-if="showSearchDropdown"
                class="dq-search-dropdown"
              >
                <div class="dq-search-dropdown-head">
                  <span>Quick Results</span>
                  <button
                    type="button"
                    class="btn btn-link btn-sm p-0"
                    @click="submitHeaderSearch"
                  >
                    View all
                  </button>
                </div>

                <div
                  v-if="searchLoading"
                  class="dq-search-dropdown-state"
                >
                  <i class="ti ti-loader-2 ti-spin me-2"></i>
                  Searching...
                </div>

                <div
                  v-else-if="searchQuery.length < 2"
                  class="dq-search-dropdown-state"
                >
                  Type at least 2 characters.
                </div>

                <div
                  v-else-if="searchError"
                  class="dq-search-dropdown-state text-danger"
                >
                  {{ searchError }}
                </div>

                <div
                  v-else-if="!searchSections.length"
                  class="dq-search-dropdown-state"
                >
                  No matching results.
                </div>

                <div v-else class="dq-search-dropdown-body">
                  <div
                    v-for="section in searchSections"
                    :key="section.key"
                    class="dq-search-section"
                  >
                    <div class="dq-search-section-title">
                      <i :class="`ti ti-${section.icon || 'search'}`"></i>
                      <span>{{ section.label }}</span>
                    </div>
                    <button
                      v-for="item in section.items"
                      :key="`${section.key}-${item.id}`"
                      type="button"
                      class="dq-search-result"
                      @click="openSearchResult(item)"
                    >
                      <div class="dq-search-result-main">
                        <span class="dq-search-result-title">{{ item.title }}</span>
                        <span
                          v-if="item.subtitle"
                          class="dq-search-result-subtitle"
                        >
                          {{ item.subtitle }}
                        </span>
                      </div>
                      <i class="ti ti-arrow-up-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Horizontal Single -->
          <div class="sidebar sidebar-horizontal" id="horizontal-single">
            <div class="sidebar-menu">
              <div class="main-menu">
                <ul class="nav-menu">
                  <template v-for="item in sideBarData" :key="item.tittle">
                    <li v-if="shouldShowSection(item)" class="menu-title">
                      <span>{{ item.tittle }}</span>
                    </li>
                    <template
                      v-for="menu in item.menu"
                      :key="menu.menuValue"
                    >
                      <li
                        v-if="
                          shouldShowMenu(menu) &&
                          !menu.hasSubRoute &&
                          menu.menuValue === 'Application'
                        "
                      >
                        <router-link :to="menu.route">
                          <i :class="'ti ti-' + menu.icon"></i>
                          <span>{{ menu.menuValue }}</span>
                        </router-link>
                      </li>
                      <li
                        class="submenu"
                        v-else-if="
                          shouldShowMenu(menu) &&
                          menu.hasSubRoute &&
                          (menu.menuValue === 'Dashboard' ||
                            menu.menuValue === 'Applications' ||
                            menu.menuValue === 'Super Admin' ||
                            menu.menuValue === 'Layouts')
                        "
                        @click="expandSubMenus(menu)"
                      >
                        <a
                          href="javascript:void(0)"
                          :class="{ subdrop: menu.showSubRoute }"
                        >
                          <i :class="'ti ti-' + menu.icon"></i>
                          <span>{{ menu.menuValue }}</span>
                          <span class="menu-arrow"></span>
                        </a>
                        <ul
                          :class="{
                            'd-block': menu.showSubRoute,
                            'd-none': !menu.showSubRoute,
                          }"
                        >
                          <template
                            v-for="subMenu in menu.subMenus"
                            :key="subMenu.menuValue"
                          >
                            <li>
                              <router-link
                                v-if="shouldShowSub(menu, subMenu)"
                                :to="subMenu.route"
                                >{{ subMenu.menuValue }}</router-link
                              >
                            </li>
                          </template>
                        </ul>
                      </li>
                      <li
                        v-else-if="shouldShowMenu(menu) && menu.hasSubRouteTwo"
                        class="submenu"
                      >
                        <a
                          href="javascript:void(0);"
                          @click="openMenu(menu)"
                          :class="{
                            subdrop: openMenuItem === menu,
                            active: route_array[0] === menu.active_link,
                          }"
                        >
                          <i :class="'ti ti-' + menu.icon"></i
                          ><span>{{ menu.menuValue }}</span>
                          <span class="menu-arrow"></span>
                        </a>
                        <ul
                          :class="{
                            'd-block': openMenuItem === menu,
                            'd-none': openMenuItem !== menu,
                          }"
                        >
                          <li
                            v-for="subMenus in menu.subMenus"
                            :key="subMenus.menuValue"
                            v-if="shouldShowSub(menu, subMenus)"
                            :class="{
                              'submenu submenu-two':
                                subMenus.menuValue === 'Calls' ||
                                subMenus.menuValue === 'Projects' ||
                                subMenus.menuValue === 'Crm' ||
                                subMenus.menuValue === 'Employee' ||
                                subMenus.menuValue === 'Tickets' ||
                                subMenus.menuValue === 'Attendance' ||
                                subMenus.menuValue === 'Performance' ||
                                subMenus.menuValue === 'Training' ||
                                subMenus.menuValue === 'Requirment' ||
                                subMenus.menuValue === 'Sales' ||
                                subMenus.menuValue === 'Accounting' ||
                                subMenus.menuValue === 'Payroll' ||
                                subMenus.menuValue === 'Assets' ||
                                subMenus.menuValue === 'Help & Supports' ||
                                subMenus.menuValue === 'User Management' ||
                                subMenus.menuValue === 'Reports' ||
                                subMenus.menuValue === 'General Settings' ||
                                subMenus.menuValue === 'Website Settings' ||
                                subMenus.menuValue === 'App Settings' ||
                                subMenus.menuValue === 'System Settings' ||
                                subMenus.menuValue === 'Financial Settings' ||
                                subMenus.menuValue === 'Other Settings' ||
                                subMenus.menuValue === 'Blogs' ||
                                subMenus.menuValue === 'Locations' ||
                                subMenus.menuValue === 'Login' ||
                                subMenus.menuValue === 'Register' ||
                                subMenus.menuValue === 'Forgot Password' ||
                                subMenus.menuValue === 'Reset Password' ||
                                subMenus.menuValue === 'Email Verification' ||
                                subMenus.menuValue === '2 Step Verification' ||
                                subMenus.menuValue === 'Base UI' ||
                                subMenus.menuValue === 'Advanced UI' ||
                                subMenus.menuValue === 'Forms' ||
                                subMenus.menuValue === 'Tables' ||
                                subMenus.menuValue === 'Charts' ||
                                subMenus.menuValue === 'Icons',
                            }"
                          >
                            <template v-if="!subMenus.customSubmenuTwo">
                              <router-link :to="subMenus.route">{{
                                subMenus.menuValue
                              }}</router-link>
                            </template>
                            <template v-else-if="subMenus.customSubmenuTwo">
                              <a
                                href="javascript:void(0);"
                                @click="openSubmenuOne(subMenus)"
                                :class="{
                                  subdrop: openSubmenuOneItem === subMenus,
                                }"
                                >{{ subMenus.menuValue
                                }}<span class="menu-arrow inside-submenu"></span
                              ></a>
                              <ul
                                :class="{
                                  'd-block': openSubmenuOneItem === subMenus,
                                  'd-none': openSubmenuOneItem !== subMenus,
                                }"
                              >
                                <li
                                  v-for="subMenuTwo in subMenus.subMenusTwo"
                                  :key="subMenuTwo.menuValue"
                                  v-if="
                                    shouldShowSubTwo(
                                      menu,
                                      subMenus,
                                      subMenuTwo,
                                    )
                                  "
                                >
                                  <router-link :to="subMenuTwo.route">{{
                                    subMenuTwo.menuValue
                                  }}</router-link>
                                </li>
                              </ul>
                            </template>
                          </li>
                        </ul>
                      </li>
                    </template>
                  </template>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Horizontal Single -->

          <div class="d-flex align-items-center">
            <div class="me-1">
              <a
                href="javascript:void(0);"
                class="btn btn-menubar btnFullscreen"
                @click="initFullScreen"
              >
                <i class="ti ti-maximize"></i>
              </a>
            </div>
           
          

            <div class="me-1 notification_item">
              <a
                href="javascript:void(0);"
                class="btn btn-menubar position-relative me-1"
                id="notification_popup"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-bell"></i>
                <span
                  v-if="notificationStore.unreadCount > 0"
                  class="header-notif-count"
                  :class="{ 'header-notif-count--wide': notificationStore.unreadCount > 9 }"
                  aria-hidden="true"
                >
                  {{ notificationStore.unreadCount > 99 ? "99+" : notificationStore.unreadCount }}
                </span>
                <span v-else class="notification-status-dot"></span>
              </a>
              <div class="dropdown-menu dropdown-menu-end notification-dropdown p-4">
                <div class="d-flex align-items-center justify-content-between border-bottom p-0 pb-3 mb-3">
                  <h4 class="notification-title mb-0">
                    Notifications
                    <span class="text-muted fs-14">({{ notificationStore.unreadCount }})</span>
                  </h4>
                  <div class="d-flex align-items-center">
                    <a
                      href="javascript:void(0);"
                      class="text-primary fs-15 me-3 lh-1"
                      @click.prevent="handleMarkAllRead"
                      >Mark all as read</a
                    >
                    <a href="javascript:void(0);" class="text-dark fs-15 lh-1" @click.prevent="openNotificationsPage">View all</a>
                  </div>
                </div>
                <div class="noti-content">
                  <div v-if="notificationStore.dropdownLoading" class="py-4 text-center text-muted">
                    <span class="spinner-border spinner-border-sm me-2"></span>
                    Loading notifications...
                  </div>
                  <div v-else-if="!notificationStore.recent.length" class="py-4 text-center text-muted">
                    No notifications yet.
                  </div>
                  <div v-else class="d-flex flex-column">
                    <div
                      v-for="(item, index) in notificationStore.recent"
                      :key="item.id"
                      class="mb-3 pb-3"
                      :class="{ 'border-bottom': index !== notificationStore.recent.length - 1 }"
                    >
                      <a href="javascript:void(0);" @click.prevent="openNotification(item)" class="text-reset">
                        <div class="d-flex">
                          <span
                            class="avatar avatar-lg me-2 flex-shrink-0 d-inline-flex align-items-center justify-content-center rounded-circle"
                            :class="notificationIconClass(item.color)"
                          >
                            <i :class="`ti ti-${item.icon || 'bell'}`"></i>
                          </span>
                          <div class="flex-grow-1 min-w-0">
                            <div class="d-flex align-items-center justify-content-between gap-2">
                              <p class="mb-1 fw-semibold text-dark text-truncate">{{ item.title }}</p>
                              <span v-if="!item.is_read" class="badge bg-warning-transparent text-warning">New</span>
                            </div>
                            <p class="mb-1">{{ item.message }}</p>
                            <span>{{ item.created_human }}</span>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="d-flex p-0">
                  <a href="javascript:void(0);" class="btn btn-light w-100 me-2" @click.prevent="handleClearNotifications"
                    >Clear All</a
                  >
                  <a href="javascript:void(0);" class="btn btn-primary w-100" @click.prevent="openNotificationsPage"
                    >Open Notifications</a
                  >
                </div>
              </div>
            </div>
            <div class="dropdown profile-dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle d-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <span class="avatar avatar-sm online">
                  <img
                    :src="avatarUrl || companyLogoUrl || adminUser?.logo_url || userPlaceholder"
                    alt="Img"
                    class="img-fluid rounded-circle"
                  />
                </span>
              </a>
              <div class="dropdown-menu shadow-none">
                <div class="card mb-0">
                  <div class="card-header">
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-lg me-2 avatar-rounded">
                        <img
                          :src="
                            avatarUrl || companyLogoUrl || adminUser?.logo_url || userPlaceholder
                          "
                          alt="img"
                        />
                      </span>
                      <div>
                        <h5 class="mb-0">
                          {{ user?.first_name || adminUser?.first_name || "" }}
                          {{ user?.last_name || adminUser?.last_name || "" }}
                        </h5>
                        <p class="fs-12 fw-medium mb-0">
                          {{ user?.email || adminUser?.email || "" }}
                        </p>
                        <p v-if="isSuperAdmin" class="mb-0 mt-1">
                          <span class="badge badge-soft-primary fs-11"
                            >Super Admin</span
                          >
                        </p>
                        <p v-else-if="isAdmin" class="mb-0 mt-1">
                          <span class="badge badge-soft-dark fs-11"
                            >Company Admin</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <template
                      v-for="(item, index) in profileMenuLinks"
                      :key="`profile-link-${index}`"
                    >
                      <div
                        v-if="item.divider"
                        class="dropdown-divider my-2"
                      ></div>
                      <router-link
                        v-else
                        class="dropdown-item d-inline-flex align-items-center p-0 py-2"
                        :to="item.to"
                        @click="closeMobileSidebar"
                      >
                        <i :class="[item.icon, 'me-1']"></i>{{ item.label }}
                      </router-link>
                    </template>
                  </div>
                  <div class="card-footer">
                    <a
                      class="dropdown-item d-inline-flex align-items-center p-0 py-2"
                      href="#"
                      @click.prevent="handleLogout"
                      ><i class="ti ti-login me-2"></i>Logout</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- ✅ SUPERADMIN IMPERSONATION BANNER -->
      <div
        v-if="isImpersonating"
        class="dq-impersonation-wrap"
        role="status"
        aria-live="polite"
      >
        <div class="dq-impersonation-inner">
          <div class="dq-impersonation-left">
            <span class="dq-impersonation-dot"></span>

            <div class="dq-impersonation-text">
              <div class="dq-impersonation-title">
                You are impersonating
                <span class="dq-impersonation-company">
                  {{ impersonatedCompanyName || "Company" }}
                </span>
              </div>

              <div class="dq-impersonation-sub">
                Actions you take will affect this company’s data and settings.
              </div>
            </div>
          </div>

          <div class="dq-impersonation-right">
            <button
              type="button"
              class="btn btn-sm dq-impersonation-btn"
              :disabled="stopLoading"
              @click="stopImpersonationAndReturn"
            >
              <i class="ti ti-arrow-back-up me-1"></i>
              {{ stopLoading ? "Stopping..." : "Stop impersonating" }}
            </button>
          </div>
        </div>
      </div>
      <!-- ✅ /SUPERADMIN IMPERSONATION BANNER -->

      <button
        type="button"
        class="dq-mobile-search-trigger"
        aria-label="Search"
        @click="openMobileSearch"
      >
        <i class="ti ti-search"></i>
      </button>

      <!-- Mobile Menu -->
      <div class="dropdown mobile-user-menu">
        <a
          href="javascript:void(0);"
          class="nav-link dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          ><i class="fa fa-ellipsis-v"></i
        ></a>
        <div class="dropdown-menu dropdown-menu-end">
          <template
            v-for="(item, index) in profileMenuLinks"
            :key="`mobile-profile-link-${index}`"
          >
            <div v-if="item.divider" class="dropdown-divider"></div>
            <router-link
              v-else
              class="dropdown-item d-inline-flex align-items-center p-0 py-2"
              :to="item.to"
              @click="closeMobileSidebar"
            >
              <i :class="[item.icon, 'me-1']"></i>{{ item.label }}
            </router-link>
          </template>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="#" @click.prevent="handleLogout"
            >Logout</a
          >
        </div>
      </div>
      <!-- /Mobile Menu -->

      <div
        v-if="mobileSearchOpen"
        class="dq-mobile-search"
        role="dialog"
        aria-modal="true"
        aria-label="Search DoneQuick HR"
      >
        <div class="dq-mobile-search__header">
          <button
            type="button"
            class="dq-mobile-search__close"
            aria-label="Close search"
            @click="closeMobileSearch"
          >
            <i class="ti ti-arrow-left"></i>
          </button>
          <div class="dq-mobile-search__field">
            <i class="ti ti-search"></i>
            <input
              ref="mobileSearchInputRef"
              v-model.trim="searchQuery"
              type="search"
              placeholder="Search in HRMS"
              autocomplete="off"
              @input="handleSearchInput"
              @keyup.enter="submitHeaderSearch"
              @keydown.esc="closeMobileSearch"
            />
          </div>
        </div>

        <div class="dq-mobile-search__body">
          <div v-if="searchLoading" class="dq-search-dropdown-state">
            <i class="ti ti-loader-2 ti-spin me-2"></i>Searching...
          </div>
          <div
            v-else-if="searchQuery.length < 2"
            class="dq-search-dropdown-state"
          >
            Type at least 2 characters.
          </div>
          <div
            v-else-if="searchError"
            class="dq-search-dropdown-state text-danger"
          >
            {{ searchError }}
          </div>
          <div
            v-else-if="!searchSections.length"
            class="dq-search-dropdown-state"
          >
            No matching results.
          </div>
          <div v-else class="dq-search-dropdown-body">
            <div
              v-for="section in searchSections"
              :key="`mobile-${section.key}`"
              class="dq-search-section"
            >
              <div class="dq-search-section-title">
                <i :class="`ti ti-${section.icon || 'search'}`"></i>
                <span>{{ section.label }}</span>
              </div>
              <button
                v-for="item in section.items"
                :key="`mobile-${section.key}-${item.id}`"
                type="button"
                class="dq-search-result"
                @click="openSearchResult(item)"
              >
                <span class="dq-search-result-main">
                  <span class="dq-search-result-title">{{ item.title }}</span>
                  <span
                    v-if="item.subtitle"
                    class="dq-search-result-subtitle"
                  >
                    {{ item.subtitle }}
                  </span>
                </span>
                <i class="ti ti-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <subscription-banner />
  <theme-settings></theme-settings>
  <layout-mobile-tabbar />
</template>

<script setup>
import {
  ref,
  computed,
  nextTick,
  onMounted,
  onBeforeUnmount,
  watch,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import { useAuthStore } from "@/stores/authStore";
import { useAccessStore } from "@/stores/accessStore";
import { useNotificationStore } from "@/stores/notificationStore";
import globalSearchService from "@/services/globalSearch.service";
import sideBarDataJson from "@/assets/json/sidebar-menuone.json";
import HrPayrollMark from "@/components/branding/hr-payroll-mark.vue";
import LayoutMobileTabbar from "@/views/layouts/layout-mobile-tabbar.vue";
import {
  findAccessiblePages,
  mergeSearchSections,
} from "@/utils/globalSearchPages";
import {
  canShowCrmMenuForEmployee,
  isCrmMenuValue,
} from "@/utils/crmAccess";
import userPlaceholder from "@/assets/img/profiles/avatar-27.jpg";
import { resolveAvatarUrl } from "@/utils/imageHelpers";

// state
const notificationClass = ref("pe-1");
const sideBarData = ref(sideBarDataJson);
const openMenuItem = ref(null);
const openSubmenuOneItem = ref(null);
const route_array = ref([]); // kept as in original

const router = useRouter();
const route = useRoute();
const auth = useAuthStore();
const accessStore = useAccessStore();
const notificationStore = useNotificationStore();
let notificationPoller = null;
let searchTimer = null;
const currentRoles = computed(() => auth.user?.roles || []);
const isSuperAdmin = computed(() => currentRoles.value.includes("SuperAdmin"));
const isAdmin = computed(() => currentRoles.value.includes("Admin"));
const isHr = computed(
  () =>
    currentRoles.value.includes("Hr") || currentRoles.value.includes("HR"),
);
const isEmployeeRole = computed(() => currentRoles.value.includes("Employee"));
const isClientRole = computed(() => currentRoles.value.includes("Client"));
const isPureEmployee = computed(
  () =>
    isEmployeeRole.value &&
    !isAdmin.value &&
    !isHr.value &&
    !isSuperAdmin.value,
);
const isPureClient = computed(
  () =>
    isClientRole.value &&
    !isEmployeeRole.value &&
    !isAdmin.value &&
    !isHr.value &&
    !isSuperAdmin.value,
);
const homeRoute = computed(() =>
  currentRoles.value.includes("SuperAdmin")
    ? "/super-admin/dashboard"
    : currentRoles.value.includes("Client") &&
      !currentRoles.value.includes("Employee") &&
      !currentRoles.value.includes("Admin") &&
      !currentRoles.value.includes("Hr") &&
      !currentRoles.value.includes("HR")
    ? "/crm/clients"
    : currentRoles.value.includes("Employee") &&
      !currentRoles.value.includes("Admin") &&
      !currentRoles.value.includes("Hr") &&
      !currentRoles.value.includes("HR")
    ? "/dashboard/employee-dashboard"
    : "/dashboard/admin-dashboard",
);

const user = computed(() => auth.user?.employee || null);
const avatarUrl = computed(() =>
  user.value ? resolveAvatarUrl(user.value.avatar_url) : "",
);

const adminUser = computed(() => auth.user || null);

// Prefer live company logo_url (tenant-media aware) over stale users.logo_url.
const companyLogoUrl = computed(() => {
  const companies = adminUser.value?.companies || [];
  const first = Array.isArray(companies) ? companies[0] : null;
  const raw = first?.logo_url || "";
  return raw ? resolveAvatarUrl(raw) : "";
});

const profileMenuLinks = computed(() => {
  if (isSuperAdmin.value) {
    return [
      {
        label: "Platform Dashboard",
        to: "/super-admin/dashboard",
        icon: "ti ti-layout-dashboard",
      },
      {
        label: "Companies",
        to: "/super-admin/companies",
        icon: "ti ti-building-skyscraper",
      },
      {
        label: "Workspaces",
        to: "/super-admin/tenants",
        icon: "ti ti-cloud-computing",
      },
      {
        label: "Migration Center",
        to: "/super-admin/migration-center",
        icon: "ti ti-database-import",
      },
      { divider: true },
      {
        label: "Notifications",
        to: "/notifications",
        icon: "ti ti-bell",
      },
    ];
  }

  if (isAdmin.value) {
    return [
      {
        label: "Company Profile",
        to: "/pages/company-profile",
        icon: "ti ti-building",
      },
      {
        label: "Settings",
        to: "/general-settings/profile-settings",
        icon: "ti ti-settings",
      },
      {
        label: "Security",
        to: "/general-settings/security-settings",
        icon: "ti ti-shield-lock",
      },
      { divider: true },
      {
        label: "Notifications",
        to: "/notifications",
        icon: "ti ti-bell",
      },
    ];
  }

  return [
    {
      label: "My Profile",
      to: {
        path: "/pages/profile",
        query: {
          id: user.value?.employee?.id || auth.user?.employee?.id,
        },
      },
      icon: "ti ti-user-circle",
    },
    {
      label: "Notifications",
      to: "/notifications",
      icon: "ti ti-bell",
    },
  ];
});

const searchShellRef = ref(null);
const searchInputRef = ref(null);
const mobileSearchInputRef = ref(null);
const mobileSearchOpen = ref(false);
const searchQuery = ref("");
const searchLoading = ref(false);
const searchError = ref("");
const searchSections = ref([]);
const searchDropdownOpen = ref(false);
const showSearchDropdown = computed(() => searchDropdownOpen.value);

// helpers
function isElementVisible(element) {
  return element && (element.offsetWidth > 0 || element.offsetHeight > 0);
}

function slideDownSubmenu() {
  const subdropPlusUl = document.getElementsByClassName("subdrop");
  for (let i = 0; i < subdropPlusUl.length; i++) {
    const submenu = subdropPlusUl[i].nextElementSibling;
    if (submenu && submenu.tagName.toLowerCase() === "ul") {
      submenu.style.display = "block";
    }
  }
}

function slideUpSubmenu() {
  const subdropPlusUl = document.getElementsByClassName("subdrop");
  for (let i = 0; i < subdropPlusUl.length; i++) {
    const submenu = subdropPlusUl[i].nextElementSibling;
    if (submenu && submenu.tagName.toLowerCase() === "ul") {
      submenu.style.display = "none";
    }
  }
}

// listeners
function handleMouseover(e) {
  e.stopPropagation();

  const body = document.body;
  const toggleBtn = document.getElementById("toggle_btn");

  if (body.classList.contains("mini-sidebar") && isElementVisible(toggleBtn)) {
    const target = e.target.closest(".sidebar, .header-left");

    if (target) {
      body.classList.add("expand-menu");
      slideDownSubmenu();
    } else {
      body.classList.remove("expand-menu");
      slideUpSubmenu();
    }

    e.preventDefault();
  }
}

function handleOutsideClick(event) {
  // Check if the click was outside the notification item
  const notificationItem = event.target.closest(".notification-item");
  if (!notificationItem) {
    notificationClass.value = "";
  }

  if (
    searchDropdownOpen.value &&
    searchShellRef.value &&
    !searchShellRef.value.contains(event.target)
  ) {
    closeSearchDropdown();
  }
}

function handleGlobalKeydown(event) {
  if ((event.ctrlKey || event.metaKey) && event.key === "/") {
    event.preventDefault();
    searchInputRef.value?.focus();
    searchDropdownOpen.value = true;
  }
}

// methods → functions
function handleClick(event) {
  event.stopPropagation();

  if (notificationClass.value === "pe-1 notification-item-show") {
    notificationClass.value = "";
    document.removeEventListener("click", handleOutsideClick);
  } else {
    notificationClass.value = "pe-1 notification-item-show";
    document.addEventListener("click", handleOutsideClick);
  }
}

function toggleSidebar1() {
  const body = document.body;
  body.classList.toggle("slide-nav");
  body.classList.toggle(
    "dq-mobile-drawer-open",
    body.classList.contains("slide-nav"),
  );
  window.dispatchEvent(
    new CustomEvent("dq-mobile-sidebar", {
      detail: { open: body.classList.contains("slide-nav") },
    }),
  );
}

function toggleSidebar() {
  const body = document.body;
  body.classList.toggle("mini-sidebar");
}

function initFullScreen() {
  document.body.classList.toggle("fullscreen-enable");
  if (
    !document.fullscreenElement &&
    !document.mozFullScreenElement &&
    !document.webkitFullscreenElement
  ) {
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
    } else if (document.documentElement.mozRequestFullScreen) {
      document.documentElement.mozRequestFullScreen();
    } else if (document.documentElement.webkitRequestFullscreen) {
      document.documentElement.webkitRequestFullscreen(
        Element.ALLOW_KEYBOARD_INPUT,
      );
    }
  } else {
    if (document.cancelFullScreen) {
      document.cancelFullScreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen();
    }
  }
}

function expandSubMenus(menu) {
  sideBarData.value.forEach((item) => {
    item.menu.forEach((subMenu) => {
      if (subMenu !== menu) {
        subMenu.showSubRoute = false;
      }
    });
  });
  menu.showSubRoute = !menu.showSubRoute;
}

function openMenu(menu) {
  openMenuItem.value = openMenuItem.value === menu ? null : menu;
}

function openSubmenuOne(subMenus) {
  openSubmenuOneItem.value =
    openSubmenuOneItem.value === subMenus ? null : subMenus;
}

function closeMobileSidebar() {
  if (window.innerWidth < 992) {
    document.body.classList.remove("slide-nav", "dq-mobile-drawer-open");
    window.dispatchEvent(
      new CustomEvent("dq-mobile-sidebar", {
        detail: { open: false },
      }),
    );
  }
}

function openMobileSearch() {
  mobileSearchOpen.value = true;
  document.body.classList.add("dq-mobile-search-open");
  searchDropdownOpen.value = true;
  nextTick(() => mobileSearchInputRef.value?.focus());
}

function closeMobileSearch() {
  mobileSearchOpen.value = false;
  document.body.classList.remove("dq-mobile-search-open");
  closeSearchDropdown();
}

function hasPermission(permission) {
  if (typeof auth?.can === "function") {
    return !!auth.can(permission);
  }

  return Array.isArray(auth?.permissions)
    ? auth.permissions.includes(permission)
    : false;
}

function shouldShowMenu(menu) {
  if (!menu || typeof menu !== "object") return false;
  if (menu.menuValue === "Super Admin" && !isSuperAdmin.value) return false;
  if (menu.menuValue === "Billing") return isAdmin.value;

  if (!isPureEmployee.value && !isPureClient.value) {
    return true;
  }

  if (isPureClient.value) {
    const visibleMenus = [];
    if (hasPermission("Client.Read")) visibleMenus.push("Clients");
    if (hasPermission("Contact.Read")) visibleMenus.push("Contacts");
    if (hasPermission("Project.Read") || hasPermission("Task.Read")) {
      visibleMenus.push("Projects");
    }
    if (hasPermission("Invoice.Read") || hasPermission("Payment.Read")) {
      visibleMenus.push("Sales");
    }
    return visibleMenus.includes(menu.menuValue);
  }

  const name = menu.menuValue;

  if (isCrmMenuValue(name)) {
    return canShowCrmMenuForEmployee(name, hasPermission);
  }

  const denyForEmployee = [
    "Employees",
    "Employee",
    "Employee Details",
    "Promotion",
    "Resignation",
    "Termination",
    "Sales",
    "Accounting",
    "Assets",
    "Help & Supports",
    "User Management",
    "Reports",
    "Settings",
    "Billing",
    "Super Admin",
  ];

  return !denyForEmployee.includes(name);
}

function shouldShowSub(parentMenu, subMenu) {
  if (!parentMenu || !subMenu) return false;
  const parent = parentMenu.menuValue;
  const name = subMenu.menuValue;

  if (!parent || !name) return false;

  if (isPureClient.value) {
    if (parent === "Projects") {
      return (
        (name === "Projects" && hasPermission("Project.Read")) ||
        ((name === "Tasks" || name === "Task Board") &&
          hasPermission("Task.Read"))
      );
    }

    if (parent === "Sales") {
      return (
        (name === "Invoices" && hasPermission("Invoice.Read")) ||
        (name === "Payments" && hasPermission("Payment.Read"))
      );
    }

    return true;
  }

  if (
    parent === "Applications" &&
    name === "Invoices" &&
    isPureEmployee.value
  ) {
    return false;
  }

  if (parent === "Dashboard" && name === "Employee Dashboard") {
    return isPureEmployee.value;
  }

  if (parent === "Attendance" && name === "Attendance (Employee)") {
    return isPureEmployee.value || isSuperAdmin.value;
  }

  if (parent === "Attendance" && name === "Attendance (Admin)") {
    return !isPureEmployee.value;
  }

  if (parent === "Attendance" && name === "Timesheets") {
    return !isPureEmployee.value;
  }

  if (parent === "Attendance" && name === "My Timesheets") {
    return isPureEmployee.value || isSuperAdmin.value;
  }

  if (parent === "Attendance" && name === "Shift & Schedule") {
    return !isPureEmployee.value;
  }

  if (parent === "Attendance" && name === "Leaves") {
    return true;
  }

  if (
    parent === "Payroll" &&
    (name === "My Payslips" || name === "My P9")
  ) {
    return isPureEmployee.value || isSuperAdmin.value;
  }

  if (parent === "Payroll" && name === "Payroll Presets") {
    return isSuperAdmin.value;
  }

  if (isPureEmployee.value) {
    if (parent === "Dashboard") return false;
    if (parent === "Payroll") return false;
    if (parent === "Attendance") return true;

    if (parent === "Performance") {
      return (
        name === "Performance Review List" || name === "Performance Appraisal"
      );
    }

    if (parent === "Training") {
      return name === "Training List";
    }
  }

  return true;
}

function shouldShowSubTwo(parentMenu, subMenu, subMenuTwo) {
  if (!parentMenu || !subMenu || !subMenuTwo) return false;
  const parent = parentMenu.menuValue;
  const group = subMenu.menuValue;
  const name = subMenuTwo.menuValue;

  if (!parent || !group || !name) return false;

  if (isPureClient.value) {
    return false;
  }

  if (isPureEmployee.value) {
    if (parent === "Attendance" && group === "Leaves") {
      return name === "Leave (Employee)";
    }
    return false;
  }

  return true;
}

function shouldShowSection(section) {
  return Array.isArray(section?.menu)
    ? section.menu.some((menu) => shouldShowMenu(menu))
    : false;
}

function handleLogout() {
  console.log("Logout clicked");
  auth.logout();
  router.push("/login");
}

function notificationIconClass(color) {
  return {
    "bg-primary-transparent text-primary": color === "primary",
    "bg-success-transparent text-success": color === "success",
    "bg-warning-transparent text-warning": color === "warning",
    "bg-danger-transparent text-danger": color === "danger",
    "bg-info-transparent text-info": color === "info",
  };
}

async function openNotification(item) {
  if (!item.is_read) {
    await notificationStore.markRead(item.id, true);
  }

  if (item.action_url) {
    await router.push(item.action_url);
  } else {
    await router.push("/notifications");
  }
  closeMobileSidebar();
}

async function handleMarkAllRead() {
  await notificationStore.markAllRead();
}

async function handleClearNotifications() {
  await notificationStore.clearAll();
}

async function openNotificationsPage() {
  await router.push("/notifications");
  closeMobileSidebar();
}

function closeSearchDropdown() {
  searchDropdownOpen.value = false;
}

function clearSearchResults() {
  searchSections.value = [];
  searchError.value = "";
}

function clearHeaderSearch() {
  searchQuery.value = "";
  clearSearchResults();
  closeSearchDropdown();
}

function handleSearchFocus() {
  searchDropdownOpen.value = true;
}

function normalizeSearchPayload(query, payload) {
  const pageItems = findAccessiblePages(query, auth, accessStore, 4);
  const dataSections = Array.isArray(payload?.sections) ? payload.sections : [];
  searchSections.value = mergeSearchSections(pageItems, dataSections);
}

async function runSearch(query) {
  const q = String(query || "").trim();

  if (q.length < 2) {
    searchLoading.value = false;
    clearSearchResults();
    return;
  }

  searchLoading.value = true;
  searchError.value = "";
  try {
    await accessStore.ensureAccess();
    const res = await globalSearchService.search({ q, limit: 4 });
    normalizeSearchPayload(q, res.data || {});
  } catch (err) {
    clearSearchResults();
    searchError.value =
      err?.response?.data?.message || "Search failed. Try again.";
  } finally {
    searchLoading.value = false;
  }
}

function handleSearchInput() {
  searchDropdownOpen.value = true;
  searchError.value = "";

  if (searchTimer) {
    window.clearTimeout(searchTimer);
  }

  searchTimer = window.setTimeout(() => {
    runSearch(searchQuery.value);
  }, 220);
}

async function submitHeaderSearch() {
  const q = searchQuery.value.trim();
  closeMobileSearch();
  if (!q) {
    await router.push("/pages/search-result");
    return;
  }

  await router.push({
    path: "/pages/search-result",
    query: { q },
  });
  closeMobileSidebar();
}

async function openSearchResult(item) {
  closeMobileSearch();
  if (!item?.route) {
    await submitHeaderSearch();
    return;
  }
  await router.push(item.route);
  closeMobileSidebar();
}

function goToDetails(record) {
  const id = record._raw?.id || record.id;
  if (id) {
    router.push({ path: "/employee/employee-details", query: { id } });
    closeMobileSidebar();
  }
}

const stopLoading = ref(false);

const isImpersonating = computed(() => !!auth.user?.is_impersonated);

const impersonatedCompanyName = computed(() => {
  // Preferred: company sent from impersonation endpoint
  const fromPayload = auth.user?.impersonated_company?.company_name;

  // Fallback: use active company id to find name in user companies list
  const activeId = auth.user?.active_company_id || null;
  const fromCompanies =
    activeId && Array.isArray(auth.user?.companies)
      ? auth.user.companies.find((c) => Number(c.id) === Number(activeId))
          ?.company_name
      : null;

  return fromPayload || fromCompanies || null;
});

async function stopImpersonationAndReturn() {
  try {
    stopLoading.value = true;

    // Restore SuperAdmin session (from localStorage backup)
    auth.stopImpersonation();

    // Go back to SuperAdmin companies grid (your route)
    await router.push("/super-admin/companies");
  } finally {
    stopLoading.value = false;
  }
}

// lifecycle
onMounted(() => {
  console.log("Component mounted");
  document.addEventListener("mouseover", handleMouseover);
  document.addEventListener("click", handleOutsideClick);
  document.addEventListener("keydown", handleGlobalKeydown);
  notificationStore.fetchRecent().catch(() => {});
  notificationStore.refreshUnreadCount().catch(() => {});
  notificationPoller = window.setInterval(() => {
    notificationStore.fetchRecent().catch(() => {});
  }, 60000);
});

onBeforeUnmount(() => {
  document.removeEventListener("mouseover", handleMouseover);
  document.removeEventListener("click", handleOutsideClick);
  document.removeEventListener("keydown", handleGlobalKeydown);
  document.body.classList.remove("dq-mobile-search-open");
  if (notificationPoller) {
    window.clearInterval(notificationPoller);
  }
  if (searchTimer) {
    window.clearTimeout(searchTimer);
  }
});

watch(
  () => route.query.q,
  (value) => {
    searchQuery.value = String(value || "");
  },
  { immediate: true },
);

watch(
  () => route.fullPath,
  () => {
    closeMobileSidebar();
    closeMobileSearch();
  },
);
</script>

<style scoped>
.dq-impersonation-wrap {
  position: sticky;
  top: 0;
  z-index: 1040; /* above content, below modals */
  margin: 0 0 12px 0;
  padding: 10px 12px;
}

.dq-impersonation-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: linear-gradient(
    90deg,
    rgba(220, 53, 69, 0.12),
    rgba(255, 193, 7, 0.1)
  );
  border: 1px solid rgba(220, 53, 69, 0.25);
  border-radius: 14px;
  padding: 10px 12px;
  box-shadow: 0 10px 26px rgba(16, 24, 40, 0.1);
  backdrop-filter: blur(8px);
}

.dq-impersonation-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.dq-impersonation-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: #dc3545;
  box-shadow: 0 0 0 6px rgba(220, 53, 69, 0.12);
  flex: 0 0 auto;
}

.dq-impersonation-text {
  min-width: 0;
}

.dq-impersonation-title {
  font-weight: 700;
  font-size: 13px;
  line-height: 1.2;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dq-impersonation-company {
  display: inline-block;
  margin-left: 6px;
  padding: 3px 8px;
  border-radius: 999px;
  background: rgba(220, 53, 69, 0.12);
  border: 1px solid rgba(220, 53, 69, 0.25);
  color: #b02a37;
  max-width: 46vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.dq-impersonation-sub {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dq-impersonation-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.dq-impersonation-btn {
  border-radius: 12px;
  border: 1px solid rgba(220, 53, 69, 0.35);
  background: rgba(255, 255, 255, 0.75);
  font-weight: 700;
  padding: 8px 10px;
}

.dq-impersonation-btn:hover {
  background: rgba(255, 255, 255, 0.95);
}

@media (max-width: 576px) {
  .dq-impersonation-inner {
    flex-direction: column;
    align-items: stretch;
  }
  .dq-impersonation-right {
    width: 100%;
  }
  .dq-impersonation-btn {
    width: 100%;
  }
  .dq-impersonation-company {
    max-width: 80vw;
  }
}

/* Small corner count — keep clear of the 30×30 bell button */
.header-notif-count {
  position: absolute;
  top: 1px;
  right: 1px;
  z-index: 2;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  min-width: 14px;
  padding: 0;
  margin: 0;
  border-radius: 50%;
  background-color: #dc3545;
  color: #fff;
  font-size: 8px;
  font-weight: 700;
  line-height: 14px;
  text-align: center;
  pointer-events: none;
  box-shadow: 0 0 0 1.5px #fff;
}

.header-notif-count--wide {
  width: auto;
  min-width: 14px;
  padding: 0 3px;
  border-radius: 999px;
}

.min-w-0 {
  min-width: 0;
}

.dq-global-search {
  position: relative;
  min-width: 380px;
  max-width: 520px;
  width: min(42vw, 520px);
}

.dq-global-search .input-group {
  width: 100%;
}

.dq-search-clear {
  border: 0;
  background: transparent;
  color: #64748b;
  padding: 0 10px;
}

.dq-search-dropdown {
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.12);
  z-index: 1080;
  overflow: hidden;
}

.dq-search-dropdown-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  font-weight: 700;
  color: #0f172a;
}

.dq-search-dropdown-state {
  padding: 18px 16px;
  color: #64748b;
  font-size: 13px;
}

.dq-search-dropdown-body {
  max-height: 420px;
  overflow-y: auto;
}

.dq-search-section {
  padding: 12px 0 0;
}

.dq-search-section + .dq-search-section {
  border-top: 1px solid rgba(15, 23, 42, 0.06);
}

.dq-search-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px 10px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.dq-search-result {
  width: 100%;
  border: 0;
  background: transparent;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  text-align: left;
}

.dq-search-result:hover {
  background: rgba(15, 23, 42, 0.03);
}

.dq-search-result-main {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.dq-search-result-title {
  font-weight: 700;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dq-search-result-subtitle {
  margin-top: 2px;
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 991.98px) {
  .dq-global-search {
    min-width: 0;
    width: min(54vw, 420px);
  }
}

@media (max-width: 767.98px) {
  .dq-global-search {
    display: none;
  }
}
</style>
